import * as components from './components'

export default [
  {
    path: '/semester/detail',
    component: components.SemesterDetailView,
    name: 'semesterDetailView',
    props: true
  },
  {
    path: '/semester/calendar',
    component: components.SemesterCalendarView,
    name: 'semesterCalendarView',
    props: true
  },
  {
    path: '/semester/planner',
    component: components.SemesterPlannerView,
    name: 'semesterPlannerView',
    props: true
  },
  {
    path: '/advancedsearch/googleCalendarOauth',
    component: components.GoogleCalendarSync,
    name: 'googleCalendarSync',
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/app/semester/routes.js